module.exports = __webpack_public_path__ + "static/img/img_0728.9edf9ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/img_0728.jpg
// module id = 93br
// module chunks = 0